import { JobStatus } from "../enums/job-status.enum";
import { BaseEntity } from "@app/models/rest/base-entity";
import { Zone, ZoneBasicProjection } from "./zone";
import { Priority } from "@app/models/rest/priority";
import { Job_EmbeddedVisitProjection, Visit } from "@app/models/rest/visit";
import { LocationModel } from "@app/models/rest/location";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel,
  ProjectionRelType
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("jobs")
export class Job extends BaseEntity {
  externalJobReference: string;
  externalPropertyReference: string;
  externalProjectReference: string;
  externalCaseReference: string;
  minimumAttendance: number;
  planningWindowEnd: Date;
  planningWindowStart: Date;
  status: JobStatus;
  zone: Zone;
  location: LocationModel;
  priority: Priority;
  visitList: Array<Visit>;
  postCode: string;
}

@HateoasProjection(Job, "basic")
export class Job_BasicProjection extends BaseEntity {
  externalJobReference: string;
  externalPropertyReference: string;
  externalProjectReference: string;
  externalCaseReference: string;
  planningWindowEnd: Date;
  planningWindowStart: Date;
  minimumAttendance: number;
  status: JobStatus;
  @ProjectionRel(Zone)
  zone: ProjectionRelType<ZoneBasicProjection>;

  @ProjectionRel(Zone)
  location: ProjectionRelType<LocationModel>;

  @ProjectionRel(Priority)
  priority: ProjectionRelType<Priority>;

  postCode: string;
}

@HateoasProjection(Job, "detail")
export class Job_DetailProjection extends BaseEntity {
  externalJobReference: string;
  externalPropertyReference: string;
  externalProjectReference: string;
  externalCaseReference: string;
  minimumAttendance: number;
  planningWindowEnd: Date;
  planningWindowStart: Date;
  status: JobStatus;
  @ProjectionRel(Zone)
  zone: ProjectionRelType<ZoneBasicProjection>;
  @ProjectionRel(LocationModel)
  location: ProjectionRelType<LocationModel>;
  @ProjectionRel(Priority)
  priority: ProjectionRelType<Priority>;
  //Collection<JobSchedule_DetailProjection> getScheduleList();

  visitList: Array<Job_EmbeddedVisitProjection>;
  postCode: string;
}
